import React, { useMemo } from 'react';
import { Upload as AntdUpload, Button, List, Image } from 'antd';
import { UploadOutlined, DeleteFilled } from '@ant-design/icons';
import uploadImage from 'assets/icons/upload.png';
// import { formatBytes } from 'util/file';
// import { MIME_TYPES } from 'util/fileUtil';
import classes from './Style.module.scss';
import './FileIcon.scss';
import { formatBytes } from 'app/utils';
import { MIME_TYPES } from 'app/utils/constants';

const { Dragger } = AntdUpload;

const ItemRender = (node, file, list, actions, options) => {
  const { remove } = actions;

  const isImage = useMemo(() => {
    return Object.keys(MIME_TYPES.images)
      .reduce((acc, key) => {
        if (Array.isArray(MIME_TYPES.images[key])) {
          return [...acc, ...MIME_TYPES.images[key]];
        }
        return [...acc, MIME_TYPES.images[key]];
      }, [])
      .includes(file.type || file.mineType);
  }, [file]);

  const extension = useMemo(() => {
    const fileType = file.type || file.mineType;
    if (isImage) {
      return fileType.split('/')[1];
    }
    let ext = '';
    Object.keys(MIME_TYPES.documents).forEach((key) => {
      if (Array.isArray(MIME_TYPES.documents[key])) {
        if (MIME_TYPES.documents[key].includes(fileType)) {
          ext = key;
        }
      } else if (MIME_TYPES.documents[key] === fileType) {
        ext = key;
      }
    });

    return ext;
  }, [file, isImage]);

  const url = useMemo(() => {
    if (!isImage) return 'null';
    if (file.originFileObj) {
      return URL.createObjectURL(file.originFileObj);
    }
    return file.url || 'error';
  }, [file, isImage]);
  const shouldRemove = useMemo(() => {
    if (!options) return false;
    return options.shouldRemove;
  }, [options]);
  return (
    <List.Item
      className={classes.fileItem}
      extra={
        shouldRemove && (
          <Button type="text" danger icon={<DeleteFilled onClick={remove} />} />
        )
      }
    >
      <a target="_blank" rel="noopener noreferrer" href={url}>
        <List.Item.Meta
          avatar={
            isImage ? (
              <Image width={48} height={64} preview={false} src={url} />
            ) : (
              <div className="file-icon file-icon-md" data-type={extension} />
            )
          }
          title={file.name || file.fileName}
          description={formatBytes(file.size || file.fileSize)}
        />
      </a>
    </List.Item>
  );
};

export default function Upload(props) {
  const {
    value,
    accept,
    onChange,
    dragger,
    disabled,
    multiple,
    supportText,
    shouldRemove,
    uploadButtonText = '',
    uploadButtonProps = {}
  } = props;
  // const customRequest = (options) => {
  // Implement your custom upload logic here
  // options.file is the file being uploaded
  // You can use libraries like axios or fetch to make the upload request
  // Example:
  // const formData = new FormData();
  // formData.append('file', options.file);
  // axios.post('/upload', formData)
  //   .then(response => {
  //     // Handle the response
  //   })
  //   .catch(error => {
  //     // Handle the error
  //   });
  // };

  const handleChange = ({ fileList }) => {
    if (multiple) {
      onChange(fileList);
    } else {
      let newFileList = [...fileList];

      // Limit to one file
      newFileList = newFileList.slice(-1);
      onChange(newFileList);
    }
  };

  if (dragger) {
    return (
      <Dragger
        multiple={multiple}
        accept={accept}
        beforeUpload={() => {
          return false;
        }}
        fileList={value || []}
        className={classes.upload}
        onChange={handleChange}
        // customRequest={customRequest}
        itemRender={(...args) => ItemRender(...args, { shouldRemove })}
      >
        <div className={classes.description}>
          <img src={uploadImage} alt="upload" />
          <p className={classes.title}>
            Drop your file here, or <a>Browse</a>
          </p>
          <span className={classes.caption}>{supportText}</span>
        </div>
      </Dragger>
    );
  }
  return (
    <AntdUpload
      multiple={multiple}
      accept={accept}
      beforeUpload={() => {
        return false;
      }}
      fileList={value}
      itemRender={(...args) => ItemRender(...args, { shouldRemove })}
      className={classes.upload}
      // customRequest={customRequest}
      onChange={handleChange}
      disabled={disabled}
    >
      <Button
        type="primary"
        ghost
        icon={<UploadOutlined />}
        {...uploadButtonProps}
      >
        {uploadButtonText}
      </Button>
    </AntdUpload>
  );
}

// Upload.propTypes = {
//   shouldRemove: PropTypes.bool,
//   value: PropTypes.arrayOf(PropTypes.any),
//   accept: PropTypes.arrayOf(PropTypes.string),
//   dragger: PropTypes.bool,
//   disabled: PropTypes.bool,
//   uploadButtonText: PropTypes.string,
//   supportText: PropTypes.string,
//   onChange: PropTypes.func,
//   multiple: PropTypes.bool,
//   uploadButtonProps: PropTypes.shape({}),
// };

// Upload.defaultProps = {
//   value: [],
//   multiple: true,
//   dragger: false,
//   disabled: false,
//   uploadButtonText: 'Upload',
//   accept: [],
//   supportText: 'Support: JPG, JPEG, PNG, PDF, DOC, XLSL',
//   onChange: () => {},
//   uploadButtonProps: {},
//   shouldRemove: true,
// };
